import { formatDate } from "@angular/common";

export class MarcacaoPK {

    idFilial: number = 0;

    idPaciente: number = 0;

    idPlanoSaude: number = 0;

    dataMarcacao: Date = new Date();

    idProcedimento: number = 0;

    constructor() {
    }

    dataMarcacaoFormatada(): string {

        let dataFormatada: string = '';

        if (this.dataMarcacao) {

            dataFormatada = formatDate(this.dataMarcacao, 'ddMMyyyy', 'en');
        }

        return dataFormatada;
    }
}
